import angular from 'angular';

export default angular.module('cian.ui.mobile-click', []).directive('cianUiMobileClick', [
  '$parse',
  function ($parse) {
    return {
      link(scope, element, attrs) {
        const callbackFn = $parse(attrs.cianUiMobileClick);

        element.bind('touchstart', $event => {
          $event.preventDefault();
          $event.stopPropagation();

          scope.$apply(() => callbackFn(scope, { $event }));
        });

        element.bind('touchend', $event => {
          $event.preventDefault();
          $event.stopPropagation();
        });
      },
    };
  },
]).name;
